import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getGpsSources(options = {}) {
	return _apiRequestWrap(
		ModulesMap.GPS_SOURCES,
		ModulesConfigMap[ModulesMap.GPS_SOURCES].GET_GPS_SOURCES,
		options
	)
}

function _createGpsSource(options = {}) {
	return _apiRequestWrap(
		ModulesMap.GPS_SOURCES,
		ModulesConfigMap[ModulesMap.GPS_SOURCES].CREATE_GPS_SOURCE,
		options
	)
}

function _getGpsSource(options = {}) {
	return _apiRequestWrap(
		ModulesMap.GPS_SOURCES,
		ModulesConfigMap[ModulesMap.GPS_SOURCES].GET_GPS_SOURCE,
		options
	)
}

function _patchGpsSource(options = {}) {
	return _apiRequestWrap(
		ModulesMap.GPS_SOURCES,
		ModulesConfigMap[ModulesMap.GPS_SOURCES].PATCH_GPS_SOURCE,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.GPS_SOURCES].GET_GPS_SOURCES]: _getGpsSources,
	[ModulesConfigMap[ModulesMap.GPS_SOURCES].CREATE_GPS_SOURCE]: _createGpsSource,
	[ModulesConfigMap[ModulesMap.GPS_SOURCES].GET_GPS_SOURCE]: _getGpsSource,
	[ModulesConfigMap[ModulesMap.GPS_SOURCES].PATCH_GPS_SOURCE]: _patchGpsSource,
}
